module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "swiperContainer",
    staticClass: "swiper-container",
    style: ({
      'width': _vm.width,
      'height': _vm.height
    })
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.pagination) ? _c('div', {
    ref: "pagination",
    class: _vm.pagination
  }) : _vm._e(), _vm._v(" "), (_vm.navigation) ? _c('div', {
    ref: "prevButton",
    staticClass: "swiper-button-prev",
    on: {
      "click": _vm.prev
    }
  }) : _vm._e(), _vm._v(" "), (_vm.navigation) ? _c('div', {
    ref: "nextButton",
    staticClass: "swiper-button-next",
    on: {
      "click": _vm.next
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-eee87908"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/swiper/swiper.vue
// module id = 628
// module chunks = 1